module.exports = __webpack_public_path__ + "static/media/star.551ec5ee.svg";